<template>
  <div class="root-container">
    <portal-target name="modal-robo-employment"></portal-target>
    <!-- テンプレート一覧 -->
    <template v-if="!$route.query.view">
      <RoboTemplateList :PCTRLLOG="CTRLLOG"/>
    </template>
  </div>
</template>

<script>
import { mapState }     from 'vuex'
import RoboTemplateList from '@/components2/Robo/screen/RoboTemplateList'
import controlLogMixin  from '@/mixins/controlLogMixin'

export default {
  name: 'RoboEmployment',
  componentName: 'RoboEmployment',
  components: {
    RoboTemplateList,
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user'])
  },
  data () {
    return {
      /**
       * コンポーネント名
       * @type  {string}
       */
      COMPONENT_NAME: 'RoboEmployment',
      /**
       * GOAL設定エラー有無フラグ
       * @type  {boolean}
       */
      isGoalError: false,
      /**
       * 子コンポーネントの操作有無フラグ
       * @type  {boolean}
       */
      isOpeFlag: false,
      /**
       * 子コンポーネントの準備状態
       * @type  {boolean}
       */
      isComponentReady: false
    }
  },
  /**
   * 親コンポーネント外または子コンポーネント内での画面遷移
   * @param  {Route} to 次のルート
   * @param  {Route} from 現在のルート
   * @param  {Function} next 次のフック
   */
  beforeRouteLeave(to, from, next) {
    if (this.isComponentReady) {
      let ret = this.pageTransition()
      next(ret)
    } else {
      next()
    }
  },
  created () {
    // ユーザーのロボブックマーク取得
    this.$store.dispatch('auth/getUserChatBotBookMark', null)
  },
  watch: {
    $route (to, from) {
      location.reload()
    }
  },
  methods: {
    /**
     * シナリオ編集画面から遷移しようとしたときの処理
     */
    pageTransition () {
      // ページ遷移検出
      this.$refs.scenario.isOpeFlag()
      if (!this.isOpeFlag) {
        return true
      } else {
        // 子コンポーネントのフラグをクリアする
        this.$refs.scenario.clearOpeInfo()
        return true
      }
    },
    /**
     * GOAL設定エラー取得
     * @param  {boolean} isError GOAL設定エラー有無フラグ
     */
    returnGoalErrorCount (isError) {
      this.isGoalError = isError
      // 子コンポーネントのフラグをクリアする
      this.$refs.scenario.clearOpeInfo()
    },
    /**
     * 子コンポーネントの操作フラグ取得
     * @param  {boolean} isOpeFlag 子コンポーネントの操作有無フラグ
     */
    returnOpeFlag (isOpeFlag) {
      this.isOpeFlag = isOpeFlag
    },
    /**
     * 子コンポーネントの準備状態取得
     * @param  {boolean} isReady 子コンポーネントの準備状態
     */
    componentReady (isReady) {
      this.isComponentReady = isReady
    }
  },
}
</script>

<style lang="scss" scoped>
.root-container {
  height: 100vh;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Robo/RoboEmployment.vue